import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import AiCreditsIndicator, {
  AiCredits,
} from 'components/AiAssistant/AiCreditsIndicator';
import styles from './AiFieldAssist.module.scss';

type Props = {
  credits?: AiCredits | null;
  // Why AI spend is refused right now, if it is. Takes over the footer: with
  // the generate action disabled above it, a credits line would be answering a
  // question the user is no longer asking.
  blockedText?: string | null;
};

// Shared popover footer line: the block reason if AI is unavailable, otherwise
// the remaining AI credits. Renders nothing when there is neither (no cap
// configured with spend still admitted, or the budget isn't loaded yet).
export default function CreditsFooter({ credits, blockedText }: Props) {
  if (blockedText) {
    return (
      <div className={styles.popoverFooter}>
        <div className={styles.blockedNotice}>
          <MaterialIcon icon="info" symbolsOutlined size="md-16" />
          <Typography variant="label" block>
            {blockedText}
          </Typography>
        </div>
      </div>
    );
  }
  if (!credits) return null;
  return (
    <div className={styles.popoverFooter}>
      <AiCreditsIndicator credits={credits} />
    </div>
  );
}
